import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import { _AccountantIDType } from '../../../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectAccountantIDType = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { lista, setLista, instance } = useDataBean(_AccountantIDType)
    const [id, setID] = useState(NaN);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(item => item.DataBeanProperties.IDBusinessCore == e);
            onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
        }
    };

    const getLista = () => {
        instance.getAccountantIDTypeCatalog().then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Tipo de Cuenta"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAccountantIDType} >{item.DataBeanProperties.Description}</option>
                        )
                    })
                }
            </select>
        </>
    )
}